$(function() {
    $('.js-show-map').on('click', function showMap() {
        let $showedMap = $('.js-showed-map');
        if ($showedMap.length === 0) {
            $showedMap = $('#map').parent();
        }
        const $showedContent = $('.js-showed-content');

        if ($(this).hasClass('is-map-opened')) {
            $(this).removeClass('is-map-opened');
            $($showedMap).removeClass('is-map-opened');
            $($showedContent).removeClass('is-map-opened');

            $(this).find('.js-show-map-text').text('Map');
        } else {
            $(this).addClass('is-map-opened');
            $($showedMap).addClass('is-map-opened');
            $($showedContent).addClass('is-map-opened');

            $(this).find('.js-show-map-text').text('List');
        }
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/category/tabs.js